import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class AllowClassAttribute extends Plugin {
    init() {
        const editor = this.editor;

        editor.model.schema.extend( 'paragraph', { allowAttributes: [ 'class' ] } );

        editor.conversion.attributeToAttribute( { model: 'class', view: 'class' } );

        editor.conversion.for( 'downcast' ).attributeToElement( {
            model: {
                key: 'class',
                name: '$text'
            },
            view: ( value, { writer } ) => {
                return writer.createAttributeElement( 'p', { 'class': value } );
            },
            converterPriority: 'high',
        } );
    }
}